<mat-card class="score">
  <mat-card-content class="score__content">
    <h6>
      <mds-icon
        [key]="icons.FOOTPRINT"
        [width]="27"
        [height]="27"
      ></mds-icon>
      PEF Score
    </h6>
    @if (score) {
      <h1>{{ score }} <span>pt</span></h1>
    }
  </mat-card-content>
  <mat-card-footer class="score__footer">
    <p>*Products with lower PEF Scores have smaller environmental footprints</p>
  </mat-card-footer>
</mat-card>
